import { render, staticRenderFns } from "./DialogoAgregarApartado.vue?vue&type=template&id=a5e256a2"
import script from "./DialogoAgregarApartado.vue?vue&type=script&lang=js"
export * from "./DialogoAgregarApartado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports